<template>
  <v-container>
    <error-message ref="errorDialog" />
    <v-layout row wrap>
      <v-flex xs12>
        <h3>あなたのグラフが完成しました！</h3>
      </v-flex>
      <v-flex xs12
        >公開したグラフは自動で保存されます。マイページからご確認ください。</v-flex
      >
    </v-layout>
    <v-layout row wrap class="pt-4">
      <v-flex xs12>
        <graph-title :title="title" class="pb-1" />
        <tag-bar :tags="tags" class="pb-1" />
        <graph-image :imgURL="graphUrl" />
        <hr />
        <user-name
          :date="createdDate"
          :author="userName"
          :twitter="twitterId"
        />
        <tweet-graph
          :graphTitle="title"
          :graphId="graphId"
          :isTemplate="is_template"
          :isCollate="is_collate"
          :collateGraphId="collate_graph_id"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GraphTitle from "@/components/GraphTitleForDetail.vue";
import TagBar from "@/components/TagBarForDetail.vue";
import UserName from "@/components/UserNameForDetail.vue";
import GraphImage from "@/components/GraphImageForDetail.vue";
import TweetGraph from "@/views/TweetGraph.vue";
import dayjs from "dayjs";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    GraphImage,
    GraphTitle,
    TagBar,
    UserName,
    TweetGraph,
    ErrorMessage
  },
  data() {
    return {
      graphUrl: "",
      tags: [],
      title: "",
      graphId: 0,
      createdDate: "",
      userName: "",
      twitterId: "",
      is_template: false,
      is_collate: false,
      collate_graph_id: null
    };
  },
  async created() {
    await this.getGraph();
  },
  methods: {
    getGraph() {
      const EP = "/v1/graphs/" + this.$route.query.id;
      return this.$http
        .get(EP)
        .then(res => {
          this.graphId = res.data.graph_id;
          this.title = res.data.graph_title;
          this.tags = this.getTags(res.data.graph_tags);
          this.graphUrl = res.data.xml_data;
          this.createdDate = dayjs(res.data.created_date).format(
            "YYYY/MM/DD HH:mm:ss"
          );
          this.userName = res.data.user.twitter_name;
          this.twitterId = res.data.user.twitter_screen_name;
          if (res.data.template_graph_id) {
            this.is_template = true;
          }

          if (res.data.collate_graph_id) {
            this.is_collate = true;
            this.collate_graph_id = res.data.collate_graph_id;
          }
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの検索に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    getTags(tags) {
      const result = [];
      for (const key in tags) {
        result.push(tags[key].tag_name);
      }

      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
hr {
  $color: orange;
  color: $color;
  border-width: 0 0 4px;
  border-style: solid;
  border-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 1" width="8" height="4"><circle fill="#{$color}" cx="1" cy="0.5" r="0.5"/></svg>')
    0 0 100% repeat;
}
</style>
